import styled from "styled-components";

const FlowyFoundation = styled.div`
  height: 100%;
  width: 100%;
`;

export { FlowyFoundation };
